import {getProfile} from './profile';

export const apiProfile = {
  getProfile,
};
